import _extends from 'babel-runtime/helpers/extends';

import { fetchCreativeInfoList } from '@/api/creative/info';

export default {
  name: 'CreativeDirectionSelector',

  componentName: 'CreativeDirectionSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      remoteLoading: false,
      options: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        filterable: true,
        placeholder: '请选择创意方向',
        remote: true,
        options: this.options
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  methods: {
    remoteData: function remoteData(query) {
      var _this = this;

      this.remoteLoading = true;
      fetchCreativeInfoList({
        page: 1,
        page_size: 15,
        search_field: 'name',
        keyword: query
      }).then(function (res) {
        _this.remoteLoading = false;
        _this.options = res.data.data.list.map(function (item) {
          return _extends({}, item, {
            value: item.id,
            label: item.name
          });
        });
      }).catch(function () {
        _this.options = [];
        _this.remoteLoading = false;
      });
    },
    setOptions: function setOptions(options) {
      this.options = options;
    }
  },

  mounted: function mounted() {
    if (!this.options.length) {
      this.remoteData('');
    }
  }
};